import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import Contact from './Pages/Contact';
import Home from './Pages/Home';
import LessonPolicy from './Pages/LessonPolicy';
import Page404 from './Pages/Page404';
import Projects from './Pages/Projects';
import Resume from './Pages/Resume';
import Teaching from './Pages/Teaching';
import Work from './Pages/Work';

const TechNavigator = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="teaching" element={<Layout><Teaching /></Layout>} />
      <Route path="lessonPolicy" element={<Layout><LessonPolicy /></Layout>} />
      <Route path="projects" element={<Layout><Projects /></Layout>} />
      <Route path="work" element={<Layout><Work /></Layout>} />
      <Route path="resume" element={<Layout><Resume /></Layout>} />
      <Route path="contact" element={<Layout><Contact /></Layout>} />
      <Route path="*" element={<Layout><Page404 /></Layout>} />
    </Routes>
  )
}

export default TechNavigator